import { SKS_MASTER_API_ENDPOINT, WIJMO_LICENSEKEY } from '../environments/environment';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClientJsonpModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridMultirowModule } from '@grapecity/wijmo.angular2.grid.multirow';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { setLicenseKey } from '@grapecity/wijmo';
setLicenseKey(WIJMO_LICENSEKEY);
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ShareModule } from './share/share.module';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { GlobalErrorHandler } from './error/global-error-handler';
import { AuthenticateService } from './share/authenticate/authenticate.service';
import { LogService } from './share/log/log.service';
import { MsgService } from './share/msg/msg.service';
import { ValidationService } from './share/validation/validation.service';
import { WijmoService } from './share/wijmo/wijmo.service';
import { UtilService } from './share/util/util.service';
import { MailchangeService } from './signin/mailchange/mailchange.service';
import { AppComponent } from './app.component';
import { SigninComponent } from './signin/signin/signin.component';
import { PwchangeComponent } from './signin/pwchange/pwchange.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MailchangeComponent } from './signin/mailchange/mailchange.component';
import { NavbarService } from './navbar/navbar.service';
import { HomeComponent } from './home/home.component';
import { CardSigninComponent } from './signin/card-signin/card-signin.component';
import { QRCodeModule } from 'angular2-qrcode';
import { ColorPickerModule } from 'ngx-color-picker';
import { CardSigninService } from './signin/card-signin/card-signin.service';
import { FscSigninComponent } from './signin/fsc-signin/fsc-signin.component';
import { CognitoErrorHandlerService } from './error/cognito-error-handler.service';
import { FavoriteSigninComponent } from './signin/favorite-signin/favorite-signin.component';
import { RegisterFavComponent } from './signin/register-fav/register-fav.component';
import { RegisterFavService } from './signin/register-fav/register-fav.service';
import { ImportEmpCsvObserveUpdateService } from './general-affairs/master/import-emp-csv/import-emp-csv-observe-update.service';
import { ImportEmpCsvService } from './general-affairs/master/import-emp-csv/import-emp-csv.service';
import { AutoActComponent } from './auto-act/auto-act.component';
import { AutoActService } from './auto-act/auto-act.service';
import { AutoActStateService } from './auto-act/auto-act-state.service';
import { APP_INITIALIZER } from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";



@NgModule({
  declarations: [
    AppComponent,
    SigninComponent,
    PwchangeComponent,
    NotFoundComponent,
    NavbarComponent,
    MailchangeComponent,
    HomeComponent,
    CardSigninComponent,
    FscSigninComponent,
    FavoriteSigninComponent,
    RegisterFavComponent,
    AutoActComponent,
  ],
  exports: [
    AutoActComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    FormsModule,
    ReactiveFormsModule,
    WjGridModule,
    WjGridMultirowModule,
    WjInputModule,
    ToastrModule.forRoot(),
    BrowserAnimationsModule,
    ShareModule,
    QRCodeModule,
    ColorPickerModule,
  ],
  providers: [
    AuthenticateService,
    CognitoErrorHandlerService,
    LogService,
    MsgService,
    ValidationService,
    WijmoService,
    UtilService,
    NavbarService,
    MailchangeService,
    CardSigninService,
    RegisterFavService,
    ImportEmpCsvService,
    ImportEmpCsvObserveUpdateService,
    AutoActService,
    AutoActStateService,
    Title,
    { provide: 'SKS_MASTER_API_ENDPOINT', useValue: SKS_MASTER_API_ENDPOINT },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
      showDialog: true,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
